import { useState, useEffect } from "react";
import { getTopStoriesPanelWidget } from "../api/widgets/topStories/requests";

function useStoryblokTopStoriesPanelWidget() {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getTopStoriesPanelWidget()
      .then(data => {
        if (data) {
          setData(data);
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .then(() => setIsLoading(false));
  }, []);

  return [data, isLoading];
}

export { useStoryblokTopStoriesPanelWidget };
